import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { RADIO } from '../../../constants';
import { useFieldContext } from '../Context';
const Radio = forwardRef(({ className, id, name, value, ...restProps }, ref) => {
    const { id: fieldId } = useFieldContext();
    const radioName = name || fieldId;
    const radioId = id || (value !== undefined ? String(value) : undefined);
    return (_jsx("input", { ref: ref, name: radioName, id: radioId, className: className, type: "radio", ...restProps }));
});
Radio.displayName = RADIO;
export { Radio };
//# sourceMappingURL=Radio.js.map